"use client";

import { c as _c } from "react/compiler-runtime";
import { useState } from "react";
import { MobileNav, MobileNavHeader, MobileNavMenu, MobileNavToggle, NavBody, Navbar, NavbarButton, NavbarLogo, NavItems } from "@/components/ui/resizable-navbar";
import { AnimatedThemeToggler } from "./ui/animated-theme-toggler";
export function SiteNavbar() {
  const $ = _c(19);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = [{
      name: "Industrias",
      link: "/#industrias"
    }, {
      name: "Constituci\xF3n",
      link: "/constitucion"
    }, {
      name: "Blog",
      link: "/blog"
    }];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const navItems = t0;
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  let t1;
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <NavbarLogo />;
    t2 = <NavItems items={navItems} />;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <NavBody>{t1}{t2}<div className="relative z-30 flex items-center gap-4"><AnimatedThemeToggler className="cursor-pointer hover:-translate-y-0.5 transition duration-200" /><NavbarButton href="/contacto" variant="primary">Comenzar</NavbarButton></div></NavBody>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <NavbarLogo />;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <AnimatedThemeToggler />;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== isMobileMenuOpen) {
    t6 = () => setIsMobileMenuOpen(!isMobileMenuOpen);
    $[6] = isMobileMenuOpen;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== isMobileMenuOpen || $[9] !== t6) {
    t7 = <MobileNavHeader>{t4}<div className="flex items-center justify-end gap-4">{t5}<MobileNavToggle isOpen={isMobileMenuOpen} onClick={t6} /></div></MobileNavHeader>;
    $[8] = isMobileMenuOpen;
    $[9] = t6;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  let t9;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = () => setIsMobileMenuOpen(false);
    t9 = navItems.map(item => <a key={item.link} href={item.link} onClick={() => setIsMobileMenuOpen(false)} className="relative text-neutral-600 dark:text-neutral-300"><span className="block">{item.name}</span></a>);
    $[11] = t8;
    $[12] = t9;
  } else {
    t8 = $[11];
    t9 = $[12];
  }
  let t10;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <div className="flex w-full flex-col gap-4"><NavbarButton onClick={() => setIsMobileMenuOpen(false)} variant="primary" className="w-full" href="/contacto">Comenzar</NavbarButton></div>;
    $[13] = t10;
  } else {
    t10 = $[13];
  }
  let t11;
  if ($[14] !== isMobileMenuOpen) {
    t11 = <MobileNavMenu isOpen={isMobileMenuOpen} onClose={t8}>{t9}{t10}</MobileNavMenu>;
    $[14] = isMobileMenuOpen;
    $[15] = t11;
  } else {
    t11 = $[15];
  }
  let t12;
  if ($[16] !== t11 || $[17] !== t7) {
    t12 = <Navbar>{t3}<MobileNav>{t7}{t11}</MobileNav></Navbar>;
    $[16] = t11;
    $[17] = t7;
    $[18] = t12;
  } else {
    t12 = $[18];
  }
  return t12;
}